import React from "react";
import OnePanel from "./OnePanel";
import Styled, { LineBreak, Exhibit } from "./styles";
import { Row, Col } from "react-bootstrap";
import ChipImage1 from "./assets/chip1.png";
import ChipImage2 from "./assets/chip2.png";
import AutoImage2 from "./assets/auto2.png";
import SlidersImage from "./assets/sliders.png";

const Product = ({ activeRound }) => (
  <OnePanel title="THE PRODUCT">
    Image sensors are devices made from silicon chips that capture photons and convert the photons into electrons
    to display optical information (i.e. images). It is used in a variety of devices. Most notable are digital
    cameras and mobile phones. It is produced in a semiconductor Fabrication plant ("Fab" or "Fab Plant")
    from silicon wafers.
    <LineBreak />
    <Row>
      <Col xs={6}>
        <Styled.ImageDescription>Silicon Wafer</Styled.ImageDescription>
        <Styled.ResponsiveImage
          maxWidth="80%"
          src={ChipImage1}
          alt="chip image 1"
        />
      </Col>
      <Col xs={6}>
        <Styled.ImageDescription>Image Sensor Chip</Styled.ImageDescription>
        <Styled.ResponsiveImage
          maxWidth="80%"
          src={ChipImage2}
          alt="chip image 2"
        />
      </Col>
    </Row>
    <LineBreak count={3} />
    <Styled.Subtitle>PRODUCT FEATURES</Styled.Subtitle>
    <Styled.GreyBold>Resolution</Styled.GreyBold>
    Resolution is the fineness of details in an image. High resolution sensors are small sensors with high pixel count,
    which means the pixel has to be smaller. The smaller the pixels, the higher the resolution (the finer the details
    you can capture in an image). Mobile customers want image sensors with high resolution because 1) smartphones need
    small sensors and 2) smartphone customers want high resolution pictures. For auto customers, having a high resolution
    is not that important as fine details of the image is not as important as image detection.
    <LineBreak />
    <Styled.GreyBold>Sensitivity</Styled.GreyBold>
    Light sensitivity is a measure of the minimum amount of light needed to generate an electronic signal. Reducing pixel
    sizes (increasing the resolution), reduces light sensitivity, which has consequences both for high and low levels of
    scene luminance and for short and long exposure duration. For Auto image sensors, this increases safety risks. For
    example, when driving in fog or darkness, an image sensor with low light sensitivity might not be able to detect objects
    correctly. See picture below:
    <LineBreak />
    <Styled.ResponsiveImage src={AutoImage2} alt="auto image 2" />
    <LineBreak />
    The downsides are, when the light sensitivity is high (larger sensor with larger pixel sizes), that resolution and power
    consumption suffer. These are not negative factors for mobile sensors.
    <LineBreak />
    <Styled.GreyBold>Power</Styled.GreyBold>
    Power refers to the power efficiency of the sensor (the higher the power consumption, the lower the power efficiency).
    Power consumption of the sensor impacts the battery life of a mobile phone. Therefore the mobile customers require power
    efficient image sensors. On the other hand, power efficiency is not a critical product feature for auto customers.
    <LineBreak />
    <Styled.GreyBold>Temperature Range</Styled.GreyBold>
    Temperature range measures a sensor's ability to perform in extreme temperatures, which is an essential feature for auto
    sensors. This is a minor factor for mobile sensors as smartphones are not exposed to extreme temperatures in the way that vehicles are.
    <LineBreak />
    <Styled.GreyBold>Product Feature Ranking System</Styled.GreyBold>
    <Styled.ResponsiveImage src={SlidersImage} alt="sliders" align="right" />
    Image sensor industry (in the sim only) uses a standard ranking system to communicate the product features. Each feature
    is ranked from 1 to 10. 1 being the lowest and 10 being the highest. Customers use the ranking system to express their
    minimum product requirements (in terms of resolution, sensitivity, power, and temperature in that order). For example,
    if a customer specifies their minimum product requirements as 1, 4, 6, 8, then that customer’s image sensor requires a
    chip that has a low resolution, moderate light sensitivity efficiency and a very high power and temperature tolerance.
    Based on the customer segment information, this customer is likely an auto manufacturer. If an image sensor manufacturer
    intends to sell to this customer, its image sensor should at least meet the 1,4,6,8 requirement.
    <LineBreak />
    <Styled.GreyBold>Product Features, Development Time, and Research and Development (R&amp;D) Cost</Styled.GreyBold>
    Another impact of the product development time is, it impacts the product release date. For example, if your product
    release date is July 1, then you can’t start production until that date. As a result, your production volumes will only
    be 50% of the annual capacity.
    <LineBreak />
    <Exhibit number={2} round={activeRound} /> provides the expected research and development cost at different quality levels
    (different ranks for each product feature).
  </OnePanel>
);

export default Product;



// WEBPACK FOOTER //
// ./src/components/bcase/Product.js